/** Контент лендинга `/use-cases/broadcast-timer` (вёрстка — `UseCasePageLayout`). */

import type { UseCasePageContent } from './useCasePageContent';

export const BROADCAST_TIMER_CONTENT: UseCasePageContent = {
  heroEyebrow: 'ПРЯМЫЕ ЭФИРЫ И ВЕЩАНИЕ',
  heroLead:
    'Тайминг — основа хорошего эфира. preztimer помогает собрать понятное расписание шоу по сегментам и держать его в реальном времени: без установки, проводов и рекламы.',
  heroNote: 'Бесплатно. Без регистрации, в браузере.',

  scenarios: {
    title: 'Где пригодится',
    lead:
      'preztimer держит тайминг там, где эфир идёт по сегментам, а команда работает с разных точек студии и удалённо.',
    items: [
      {
        title: 'Прямые эфиры и студия',
        text: 'Расписание шоу по сегментам: гость, рубрика, рекламная пауза — отсчёт и переход к следующему блоку.',
      },
      {
        title: 'Многокамерные трансляции',
        text: 'Общий тайминг для аппаратной, операторов и ведущего — все видят одно время.',
      },
      {
        title: 'Удалённые гости',
        text: 'Одинаковый отсчёт у участников в разных городах, сигналы в кадр без голосовых команд.',
      },
    ],
  },

  share: {
    title: 'Просто управлять, легко делиться',
    paragraphs: [
      'preztimer — таймер с удалённым управлением: запускайте, ставьте на паузу и сбрасывайте отсчёт с любого устройства в браузере. Команда управляет эфиром на площадке или онлайн, пока вы делаете контент.',
      'Поделитесь экраном таймера и расписанием по ссылке или QR-коду — без установки и регистрации. Сообщения на экране передают подсказки ведущему и гостям.',
    ],
  },

  cloud: {
    title: 'Расписание всего эфира в браузере',
    lead:
      'Соберите таймеры на весь эфир и держите их под рукой — без лишних экранов и установки.',
    bullets: [
      'таймеры на каждый сегмент шоу;',
      'старт в заданное время и дату по расписанию;',
      'минимум ресурсов: ПК, телефон или планшет.',
    ],
  },

  communication: {
    title: 'Сообщения и координация команды',
    lead:
      'Передавайте короткие подсказки в кадр и держите всю команду на одном времени.',
    bullets: [
      'цветные сообщения гостю или ведущему — «держите микрофон ближе»;',
      'общий доступ к таймеру по ссылке и QR-коду;',
      'синхронная работа на нескольких устройствах одновременно.',
    ],
  },

  modes: {
    title: 'Прогресс, зоны и часовые пояса',
    lead:
      'Видно, сколько осталось до конца сегмента, а режимы подстраиваются под формат эфира.',
    bullets: [
      'цветовые зоны и показ перерасхода после нуля;',
      'обратный отсчёт, секундомер или часы (время суток);',
      'часы показывают местное время устройства — удобно удалённым гостям в разных зонах.',
    ],
  },

  pricing: {
    title: 'Цены',
    lead:
      'Для коротких эфиров базовых функций хватит — бесплатно. Профи добавляет больше таймеров, комнат и подключений.',
  },

  crossLink: {
    title: 'Связанный сценарий: стримы и трансляции',
    lead:
      'Twitch, YouTube, гейминг и турниры с выводом таймера в OBS — отдельная страница со своими акцентами.',
    to: '/use-cases/stream-timer',
    linkLabel: 'Таймер для стрима и трансляций',
  },

  faqSectionTitle: 'Частые вопросы о таймере для эфира',
  faqItems: [
    {
      question: 'Можно ли запланировать таймеры эфира заранее?',
      answer:
        'Да. Создайте несколько таймеров на сегменты шоу, а для нужного блока задайте старт в конкретное время и дату. Если время уже прошло, выберите ближайшее. Переход между таймерами в эфире вы делаете вручную с панели управления.',
    },
    {
      question: 'Можно ли пользоваться бесплатно?',
      answer:
        'Да. Базовых функций тайминга достаточно для коротких эфиров — это бесплатно, до 3 одновременных подключений. Для команды и больших лимитов есть лицензия Профи.',
    },
    {
      question: 'Работает ли на любом устройстве?',
      answer:
        'Да. preztimer — веб-приложение, устанавливать ничего не нужно. Откройте сайт в актуальном браузере на ПК, ноутбуке, планшете или смартфоне и работайте сразу.',
    },
    {
      question: 'Как поделиться таймером и расписанием с командой?',
      answer:
        'Откройте экран таймера по ссылке или QR-коду — он работает на нескольких устройствах одновременно. На лицензии Профи можно подключить участников команды с доступом к панели управления.',
    },
    {
      question: 'Что с часовыми поясами удалённых гостей?',
      answer:
        'Режим часов показывает местное время устройства каждого участника. Для общего тайминга используйте обратный отсчёт — он одинаков для всех, кто открыл экран таймера.',
    },
    {
      question: 'Можно ли добавить логотип и фирменные цвета на экран?',
      answer:
        'Кастом-брендинга — логотипа, своих цветов и шрифтов — сейчас нет. Экран таймера показывает крупный читаемый отсчёт, сообщения и цветовые зоны, которые видно из аппаратной и в кадре.',
    },
  ],
};
